var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 자동 로그아웃 되었습니다. "),_c('router-link',{attrs:{"to":{
      path: '/signin',
      query: { redirectUri: _vm.$route.query.redirectUri },
    }}},[_vm._v("로그인 화면으로 이동")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }